/** 32 px circle with up to two initials. Decorative: the name is always next to it. */
export const Avatar = ({ first, last, fallback }: { first?: string; last?: string; fallback: string }) => {
    const letters = `${first?.[0] ?? ''}${last?.[0] ?? ''}` || fallback[0] || '?';
    return (
        <span
            aria-hidden="true"
            className="inline-flex size-8 shrink-0 items-center justify-center rounded-chip bg-sunken text-caption font-semibold uppercase text-strong"
        >
            {letters}
        </span>
    );
};
